import * as z from "zod";

export const disconnectRyderIntegration = {
  name: "disconnectRyderIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
